import React, { useContext, useState, useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { LanguageContext } from '../Language/LanguageContext'
import { HeaderTitle, Loading, NotifyContext } from '../Library'
import { getBookingLocationDetail, getUserInTimerange, cancelBooking } from '../Network/Booking'
import { baseURL } from '../Network/Config'
import { Row, Col, Button } from 'react-bootstrap'
import dayjs from 'dayjs'
import DatePicker from 'react-datepicker'
import thumbnail from '../asset/image/thumbnail.png'
import { reserveStatus, bookingStatus } from './BookingStatus'
import { AlertModalContext } from '../Library/AlertModalContext'
import "./BookingDetail.css"
import { faCalendarCheck, faCheckCircle, faExclamationCircle, faQuestionCircle, faUserCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const formatTime = (time) => {
    const currentDate = dayjs().format("YYYY-MM-DD")
    const datewithTime = `${currentDate} ${time}`
    const datewithTimeFormatted = dayjs(datewithTime).format("H:mm")
    return datewithTimeFormatted
}

function BookingDetail() {
    const { location_id } = useParams()
    const history = useHistory()
    const notify = useContext(NotifyContext)
    const alertModalContext = useContext(AlertModalContext)
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.booking

    const [isLoading, setIsLoading] = useState(false)
    const [title, setTitle] = useState("")
    const [detail, setDetail] = useState("")
    const [selectDate, setSelectDate] = useState(new Date())
    const [operationTime, setOperationTime] = useState("")
    const [locationImage, setLocationImage] = useState(null)
    const [timerangeList, setTimerangeList] = useState([])
    const [selectedTimerange, setSelectedTimerange] = useState(null)
    const [userTimerangeList, setUserTimerangeList] = useState([])

    const fetchData = (startDate) => {
        setIsLoading(true)
        getBookingLocationDetail(location_id, startDate,
            (data)=>{
                console.log(data)
                setTitle(data.locationName)
                setDetail(data.detail)

                const openTime = formatTime(data.startOperation)
                const closeTime = formatTime(data.endOperation)
                setOperationTime(`${openTime} - ${closeTime}`)
                setLocationImage(data.imagePath)
                setTimerangeList(data.bookingTimerange)
                setIsLoading(false)
            },
            (error)=>{
                setIsLoading(false)
            })
    }

    const cancelBook = (bookingId) => {
        setIsLoading(true)
        cancelBooking(bookingId,
            ()=>{
                setIsLoading(false)
                fetchData(selectDate)
                getUserTimerange(selectedTimerange, selectDate)
                notify.showNotify(lang.cancelled_booking, lang.cancelled_booking_desc, 0)  
            },
            ()=>{
                setIsLoading(false)
            })
    }

    const onCancelBooking = (bookingId) => {
        alertModalContext.setTitle(lang.are_you_sure_to_cancel)
        alertModalContext.setDescription(lang.are_you_sure_to_cancel_desc)
        alertModalContext.setAlertType("WARNING")
        alertModalContext.setButton([
            {
                title: langCx.lang.confirm.ok,
                variant: "primary",
                onClick: ()=>{ 
                    alertModalContext.setIsShow(false) 
                    cancelBook(bookingId)
                }
            },
            {
                title: langCx.lang.confirm.cancel,
                variant: "secondary",
                onClick: ()=>{ 
                    alertModalContext.setIsShow(false) 
                }
            }
        ])
        alertModalContext.setIsShow(true)
    }

    const getUserTimerange = (timerangeId, date) => {
        setIsLoading(true)
        getUserInTimerange(timerangeId, date,
            (data) => {
                setUserTimerangeList(data)
                setIsLoading(false)
            },
            (error) => {
                setIsLoading(false)
            })
    }

    useEffect(()=>{
        fetchData(selectDate)
    },[])

    return (
        <div id="booking-detail">
            { isLoading ? <Loading/> : null }
            <HeaderTitle title={title} isShowBack backTo="/booking"/>
            <Row>
                <Col sm={6} lg={8}>
                    <div className="detail-block">
                        <div>
                            <b>{`${lang.operation_time} :`}</b>
                            <div style={{ fontSize: 14 }}>{operationTime}</div>
                        </div>
                    </div>
                    <div className="detail-block">
                        <div>
                            <b>{`${lang.detail} :`}</b>
                        </div>
                        <div style={{ fontSize: 14 }}>{detail}</div>
                    </div>
                </Col>
                <Col sm={6} lg={4}>
                    <div className="image-location">
                        <img src={locationImage !== null ? `${baseURL}${locationImage}` : thumbnail}/>
                    </div>
                    
                </Col>
            </Row>
            <div style={{ display: 'flex' }}>
                <Button style={{ marginRight: 10 }}>
                    {lang.edit_booking_location}
                </Button>
                <Button variant="success" onClick={()=>history.push(`/booking/view/${location_id}/qr_code`)}>
                    {lang.get_qr_code}
                </Button>
            </div>
            <div style={{ marginTop: 23, marginBottom: 13 }}>
                <b>{lang.see_user_timerange}</b>
            </div>
            <Row>
                <Col lg={6}>
                    <div className="content-container" style={{ marginBottom: 13 }}>
                        <div className="date-picker-container">
                            <DatePicker 
                            className="form-control"
                            selected={selectDate}
                            onChange={(date)=>{
                                date.setHours(0)
                                date.setMinutes(0)
                                date.setSeconds(0)
                                setSelectDate(date)
                                fetchData(date)
                                setSelectedTimerange(null)
                            }}
                            dateFormat={"d MMMM yyyy"}
                            />
                        </div>
                        <div className="timerange-container">
                            { timerangeList.map((item, key) => 
                            <TimeItem
                            key={key}
                            startTime={item.startTime}
                            endTime={item.endTime}
                            status={item.status}
                            remain={item.remainPeople}
                            isSelected={selectedTimerange === item.id ? true:false}
                            onClick={()=>{
                                setSelectedTimerange(item.id)
                                getUserTimerange(item.id, selectDate)
                            }}
                            />
                            )}
                        </div>
                    </div>
                </Col>
                <Col lg={6}>
                    <div className="content-container user-timerange" style={{ height: 570 }}>
                        { userTimerangeList.map((item, key) => 
                            <UserTimerangeItem
                            key={key}
                            name={`${item.firstName} ${item.lastName}`}
                            email={item.email}
                            profileImage={item.profileImagePath}
                            phone={item.phone}
                            bookNo={item.bookNo}
                            status={item.bookStatus}
                            onClickCancel={()=>onCancelBooking(item.bookId)}
                            />   
                        )}
                        { userTimerangeList.length === 0 || selectedTimerange === null ?
                        <div className="no-booking">
                            <div style={{ fontSize: 50 }}>
                                <FontAwesomeIcon icon={faCalendarCheck}/>
                            </div>
                            <div>
                                { selectedTimerange !== null ?
                                lang.no_user_booking:
                                lang.choose_timerange}
                            </div>
                        </div>
                        : null
                        }
                    </div>
                </Col>
            </Row>
        </div>
    )
}

function TimeItem({ startTime, endTime, status, remain, onClick, isSelected }){
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.booking
    var statusBadge = { icon: faQuestionCircle, color: 'grey', text: lang.no_status }

    switch(status){
        case(reserveStatus.AVAILABLE):
            statusBadge = { icon: faCheckCircle, color: 'green', text: lang.available }
            break
        case(reserveStatus.FULL):
            statusBadge = { icon: faExclamationCircle, color: 'red', text: lang.full }
            break
    }

    return(
        <div 
        className="time-item" 
        style={{
            backgroundColor: isSelected ? "#0275d8": null,
            color: isSelected ? "white": "black"
        }}
        onClick={onClick}
        role="button"
        tabIndex="0"
        aria-pressed="false"
        onKeyDown={(e)=>{
            if(e.key === "Enter"){
                onClick()
            }
        }}>
            <div style={{ marginRight: 13 }}>
                <FontAwesomeIcon icon={statusBadge.icon} color={isSelected ? "white": statusBadge.color}/>
            </div>
            <div>
                <div>
                    <b>{`${formatTime(startTime)} - ${formatTime(endTime)}`}</b>
                </div>
                <div 
                className="desc" 
                style={{ 
                    color: isSelected ? "white": statusBadge.color
                }}>
                    {statusBadge.text}
                </div>
                <div 
                className="desc"
                style={{ 
                    color: isSelected ? "white": "gray"
                }}>
                    {`${lang.remain} ${remain} ${lang.people}`}
                </div>
            </div>
            
        </div>
    )
}
function UserTimerangeItem({ name, email, phone, bookNo, status, profileImage, onClickCancel }){
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.booking
    var statusBadge = { color: "gray", text: lang.no_status }

    switch(status){
		case(bookingStatus.ACTIVE):
			statusBadge = { color: "#10A9FC", text: lang.active }
			break
		case(bookingStatus.USED):
			statusBadge = { color: "#0BB449", text: lang.used_booking }
			break
		case(bookingStatus.EXPIRED):
			statusBadge = { color: "red", text: lang.expired }
			break
		case(bookingStatus.CANCELLED):
			statusBadge = { color: "red", text: lang.cancelled }
			break
	}

    return(
        <div className="user-timerange-item">
            <div style={{ marginRight: 13 }}>
                { profileImage ?
                <img src={`${profileImage}`} className="user-img"/>
                :
                <FontAwesomeIcon icon={faUserCircle} color={"gray"} className="user-img-placeholder"/>
                }
            </div>
            <div>
                <div className="name">{name}</div>
                <div className="desc">{email}</div>
                <div className='desc'>{phone}</div>
                <div className='desc'>{`${lang.book_no} : ${bookNo}`}</div>
                <div className='desc' style={{ color: statusBadge.color }}>
                    <b>{statusBadge.text}</b>
                </div>
                { status === bookingStatus.ACTIVE ?
                <div style={{ marginTop: 10 }}>
                    <Button variant="danger" size="sm" onClick={onClickCancel}>
                        {lang.cancel_booking}
                    </Button>
                </div>
                : null
                }
            </div>
        </div>
    )
}

export default BookingDetail
